import { useContext, useState } from 'react'
import { useHistory } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { UP_AI_BRAND_NAME } from '../../app/constants/constants';
import { selectRecipeCreationOption } from '../../app/homepage/homepage.slice';
import { setLoadingRecipeCreating } from '../../app/recipeCreation/createRecipe.slice';
import { useAppDispatch } from '../../app/store/hooks';
import useLogRecipeEdit from '../../hooks/useLogRecipeEdit';
import useRecipeCreation from '../../hooks/useRecipeCreation';
import { IdeaIcon } from '../../iconRef/recipeCreationPopupIcons';
import { CloseIcon } from '../../iconRef/recipePageIcons';
import { ErrorManagementContext } from '../../utils/errorManagement/ErrorManagementProvider';
import { EventLogsEnum } from '../../utils/events';
import LoaderButton from '../buttons/loaderButton';
import LoadingUpAnimationSavingRecipe from '../LoadingUpAnimationSavingRecipe';
import styles from "./recipeCreateForm.module.css";

const warningText = "*Please enter a Recipe name"

const AIGeneratedRecipeForm = () => {
    const dispatch = useAppDispatch()
    const history = useHistory();
    const { generateAIRecipe, loading: generatingRecipe } = useRecipeCreation();
    const { cookClubLog } = useContext(ErrorManagementContext);
    const [recipeName, setRecipeName] = useState<string>('')
    const [error, setError] = useState(false)
    const { logRecipeEdit } = useLogRecipeEdit();

    const handleClose = () => {
        setError(false);
        dispatch(selectRecipeCreationOption(null));
        dispatch(setLoadingRecipeCreating(false));
        history.push("/")
    }

    const onCompleted = (recipeId: string) => {
        history.push(`/recipe/${recipeId}`);
        dispatch(selectRecipeCreationOption(null));
    }
    const onCreate = () => {
        if (!recipeName) {
            setError(true)
            return;
        }
        logRecipeEdit(EventLogsEnum.APP_RECIPE_CREATE_CHEF_GPT, {
            eventData: { prompt: recipeName }
        })
        generateAIRecipe(recipeName, (recipeId) => onCompleted(recipeId), (err) => cookClubLog(`Something went wrong. Try Again!`, "", {}, { ui: { type: "info" }, browserConsole: true }));
    }

    if (generatingRecipe) {
        return <LoadingUpAnimationSavingRecipe />
    }

    return (
        <Grid className={styles.main_grid} spacing={6}>
            <Grid container direction="row">

                <Grid className={styles.heading_style} item xs={6}>
                    <Typography variant='body3'>Create with AI</Typography>
                </Grid>
                <Grid className={styles.close_btn} item xs={6}>

                    <IconButton onClick={handleClose}><CloseIcon /></IconButton>
                </Grid>
            </Grid>
            <Typography className={styles.sub_heading} variant='caption3Light'>Create recipe using {UP_AI_BRAND_NAME}</Typography>
            <TextField
                autoFocus
                className={styles.input_box}
                color='secondary'
                fullWidth
                minRows={2}
                multiline
                onChange={e => { setRecipeName(e.target.value); setError(false) }}
                placeholder="Type your creative prompt here for some culinary magic!"
                size="small"
                value={recipeName}
                variant="outlined"
            />

            <Grid className={styles.tips} container direction="row">

                <Grid item xs={1}>
                    <IdeaIcon />
                </Grid>
                <Grid item xs={11}>
                    <Typography variant='caption3Light'>Recipe for Taylor Swift themed Milkshake</Typography>
                </Grid>
            </Grid>
            {error && <p className={styles.error}>{warningText}</p>}
            <div>
                <LoaderButton disabled={generatingRecipe} loading={generatingRecipe} onClick={onCreate}
                    text="Generate" />
            </div>
        </Grid>
    )
}

export default AIGeneratedRecipeForm;